export default {
  // '工作台': '工作台1'
}
